import React from "react";
import logo from "../images/logo.svg";
import home from "../images/icon-nav-home.svg";
import movies from "../images/icon-nav-movies.svg";
import tv from "../images/icon-nav-tv-series.svg";
import bookmark from "../images/icon-nav-bookmark.svg";
import avatar from "../images/image-avatar.png";
import homeWhite from "../images/icon-nav-home-white.svg";
import moviesWhite from "../images/icon-nav-movies-white.svg";
import tvWhite from "../images/icon-nav-tv-series-white.svg";
import bookmarkWhite from "../images/icon-nav-bookmark-white.svg";

const Navbar = ({ setSearch }) => {
	const [homeIcon, setHomeIcon] = React.useState(false);
	const [movieIcon, setMovieIcon] = React.useState(false);
	const [tvIcon, setTvIcon] = React.useState(false);
	const [bookmarkedIcon, setBookmarkedIcon] = React.useState(false);

	const searchOption = (event) => {
		if (event.target.id === "home") {
			setHomeIcon(false);
			setMovieIcon(false);
			setTvIcon(false);
			setBookmarkedIcon(false);
		} else if (event.target.id === "movies") {
			setMovieIcon(true);
			setHomeIcon(true);
			setTvIcon(false);
			setBookmarkedIcon(false);
		} else if (event.target.id === "tv") {
			setTvIcon(true);
			setMovieIcon(false);
			setHomeIcon(true);
			setBookmarkedIcon(false);
		} else {
			setBookmarkedIcon(true);
			setTvIcon(false);
			setMovieIcon(false);
			setHomeIcon(true);
		}
		return setSearch(event.target.alt.toLowerCase());
	};

	return (
		<header className="header">
			<img className="logo" src={logo} alt="Logo icon"></img>
			<nav className="header-icons">
				<img id="home" onClick={searchOption} src={homeIcon ? home : homeWhite} alt="Home"></img>
				<img id="movies" onClick={searchOption} src={movieIcon ? moviesWhite : movies} alt="Movies"></img>
				<img id="tv" onClick={searchOption} src={tvIcon ? tvWhite : tv} alt="TV Series"></img>
				<img id="bookmarked" onClick={searchOption} src={bookmarkedIcon ? bookmarkWhite : bookmark} alt="Bookmarked Shows"></img>
			</nav>
			<img className="avatar" src={avatar} alt="User avatar"></img>
		</header>
	);
};

export default Navbar;
